import React, { useState } from "react";
import { Grid, Paper, Typography, Box, TextField, Stack, Button, Chip, Divider } from "@mui/material";

function Card({ title, subtitle, children }) {
  return (
    <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: "1px solid var(--border)", bgcolor: "var(--branco)" }}>
      <Typography sx={{ fontWeight: 900, color: "var(--cise-text)" }}>{title}</Typography>
      {subtitle && <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 13, mt: 0.3 }}>{subtitle}</Typography>}
      <Box sx={{ mt: 2 }}>{children}</Box>
    </Paper>
  );
}

export default function GoalsTab() {
  const [goals, setGoals] = useState({
    weeklyLeads: 200,
    weeklyScheduled: 50,
    monthlyEnrollments: 120,
    maxAvgResponseMin: 10,
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={7}>
        <Card title="Metas do time" subtitle="Define alvo da operação SDR">
          <GridWrap>
            <TextField label="Leads (semana)" type="number" value={goals.weeklyLeads} onChange={(e) => setGoals((p) => ({ ...p, weeklyLeads: Number(e.target.value) }))} size="small" fullWidth />
            <TextField label="Agendamentos (semana)" type="number" value={goals.weeklyScheduled} onChange={(e) => setGoals((p) => ({ ...p, weeklyScheduled: Number(e.target.value) }))} size="small" fullWidth />
            <TextField label="Matrículas (mês)" type="number" value={goals.monthlyEnrollments} onChange={(e) => setGoals((p) => ({ ...p, monthlyEnrollments: Number(e.target.value) }))} size="small" fullWidth />
            <TextField label="Tempo médio máx. (min)" type="number" value={goals.maxAvgResponseMin} onChange={(e) => setGoals((p) => ({ ...p, maxAvgResponseMin: Number(e.target.value) }))} size="small" fullWidth />
          </GridWrap>

          <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
            <Button
              variant="contained"
              sx={{ textTransform: "none", fontWeight: 900, bgcolor: "var(--cise-blue)", "&:hover": { bgcolor: "var(--cise-blue)" } }}
              onClick={() => alert("Salvar metas (futuro)")}
            >
              Salvar metas
            </Button>
          </Stack>
        </Card>
      </Grid>

      <Grid item xs={12} md={5}>
        <Card title="Metas por SDR" subtitle="Opcional (individual)">
          <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 13 }}>
            Aqui entra: metas individuais de agendamento, conversão, SLA, etc.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Chip label="SDR 1 • agendamentos/semana" sx={{ fontWeight: 900, border: "1px solid var(--border)", bgcolor: "var(--branco)", mb: 1 }} />
          <Chip label="SDR 2 • conversão/mês" sx={{ fontWeight: 900, border: "1px solid var(--border)", bgcolor: "var(--branco)", mb: 1 }} />
          <Chip label="SDR 3 • tempo resposta" sx={{ fontWeight: 900, border: "1px solid var(--border)", bgcolor: "var(--branco)" }} />
        </Card>
      </Grid>
    </Grid>
  );
}

function GridWrap({ children }) {
  return (
    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr" }, gap: 1.5 }}>
      {children}
    </Box>
  );
}